type StepIndicatorProps = {
  step: number;
  stepNames: string[];
  color: string;
  className?: string;
};

const StepIndicator = ({ step, stepNames, color, className = "" }: StepIndicatorProps) => {
  return (
    <div className={`flex justify-center mx-auto ${className}`}>
      <div className="flex items-center gap-2 sm:gap-6 w-full justify-center">
        {stepNames.map((name, index) => (
          <div key={index} className="flex items-center">
            <div className="flex flex-col items-center">
              <div
                className={`w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center border-2 font-semibold text-xs sm:text-sm md:text-base transition-all duration-200 ${
                  step >= index + 1
                    ? `border-${color}-600 bg-${color}-600 text-white shadow-md`
                    : "border-gray-300 bg-white text-gray-400"
                }`}
              >
                {index + 1}
              </div>
              <span
                className={`mt-1 sm:mt-2 font-medium text-[10px] sm:text-xs md:text-sm text-center transition-colors duration-200 max-w-[60px] sm:max-w-none leading-tight ${
                  step >= index + 1 ? `text-${color}-600` : "text-gray-400"
                }`}
              >
                {name}
              </span>
            </div>

            {index < stepNames.length - 1 && (
              <div
                className={`h-0.5 w-6 sm:w-12 md:w-20 mx-1 sm:mx-2 transition-colors duration-200 ${
                  step > index + 1 ? `bg-${color}-600` : "bg-gray-300"
                }`}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepIndicator;
